import React from 'react'

export default function WorkExperienceItem(props) {
    const {designation,company,duration}=props.data;
  return (
    <>
    <div className="timeline-box">
                	<div className="timeline-title">
                    	<div className="timeline-img">
                            <img src="https://ninjasfiles.s3.amazonaws.com/asset_0000000000000030_1550710829_ninjasicon.png" />
                        </div>
                        <div className="timeline-details">
                            <h3>
                                {designation}
                            </h3>
                            <h4>
                                {company}
                            </h4>
                            <p>
                                {duration}
                            </p>
                        </div>
                    </div>
                </div>
    </>
  )
}
